// Filter/Redirect.html
tabApp.filter('redirectHttps', function() {
    return function(url) {
        if (!url) {
            return '';
        }
        var newURL;
        // check if URL is http or https
        // First: handle http
        if (url.indexOf('https') < 0) {
            newURL = 'http://' + window.location.hostname + '/redirect.html?ref=' + url 
        }
        // Second: Handle https
         else {
             return url
         }

        return newURL;
    };
}); 